import ImageComponent from '@/src/components/common/ImageComponent'
import { getSingleBlogPath } from '@/src/routes/routes'
import { IStoriesAPIResponseDataArticlesEntity } from '@/src/types/stories'
import Link from 'next/link'

function stripMarkdown(md: string): string {
  return md
    .replace(/#{1,6}\s+/g, '')
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    .replace(/~~(.*?)~~/g, '$1')
    .replace(/`{1,3}[^`]*`{1,3}/g, '')
    .replace(/!\[.*?\]\(.*?\)/g, '')
    .replace(/\[([^\]]+)\]\(.*?\)/g, '$1')
    .replace(/^>\s+/gm, '')
    .replace(/^[-*+]\s+/gm, '')
    .replace(/^\d+\.\s+/gm, '')
    .replace(/\r?\n+/g, ' ')
    .trim()
}

interface BlogCardProps {
  post: IStoriesAPIResponseDataArticlesEntity
  view: 'grid' | 'list'
}


export default function BlogCard({ post, view }: BlogCardProps) {
  if (view === 'list') {
    return (
      <Link
        href={getSingleBlogPath(post?.slug)}
        className="group flex gap-5 md:gap-8 bg-white border border-muted-color rounded-2xl overflow-hidden hover:shadow-card-btn transition-shadow duration-300"
      >
        <div className="relative w-36 sm:w-52 md:w-64 shrink-0 bg-secondary-background-color overflow-hidden">
          <div className="absolute inset-0 transition-transform duration-500 group-hover:scale-105">
            <ImageComponent src={post?.image} alt={post?.title} object_cover={true} />
          </div>
        </div>

        <div className="flex flex-col justify-center gap-3 py-16 pr-5 md:pr-8 flex-1 min-w-0">
          <h2 className="font-semibold text-heading-color text-base md:text-lg lg:text-xl leading-snug line-clamp-2 group-hover:text-accent-color transition-colors duration-200">
            {post?.title}
          </h2>
          <p className="text-sm font-light text-body-color/70 leading-relaxed line-clamp-2 hidden sm:block">
            {post?.content ? stripMarkdown(post.content) : ''}
          </p>
        </div>
      </Link>
    )
  }

  return (
    <Link href={getSingleBlogPath(post.slug)} className="group flex flex-col gap-4 cursor-pointer">
      <div className="relative aspect-4/3 w-full bg-secondary-background-color rounded-2xl overflow-hidden">
        <div className="absolute inset-0 transition-transform duration-500 group-hover:scale-105">
          <ImageComponent src={post?.image} alt={post?.title} object_cover={true} />
        </div>
      </div>

      <div className="space-y-2.5 px-0.5">
        <h2 className="font-semibold text-heading-color text-base md:text-lg leading-snug line-clamp-2 group-hover:text-accent-color transition-colors duration-200">
          {post?.title}
        </h2>
        <p className="text-sm font-light text-body-color/70 leading-relaxed line-clamp-2">
          {post?.content ? stripMarkdown(post.content) : ''}
        </p>
      </div>
    </Link>
  )
}
